import { useAuthStore } from '../auth/useAuthStore'
import { normalizeActorFromMyDetails } from '../permissions/normalizeActorFromMyDetails'
import { PermissionActions } from '../permissions/permissionActions'
import { getActiveClubId } from '../router/useActiveClub'

export function useIsAdmin() {
  const authStore = useAuthStore()
  const actor = normalizeActorFromMyDetails(authStore.myDetails)

  if (actor.isSuperAdmin) {
    return true
  }

  const activeTenantId = getActiveClubId()
  const activeTenant = actor.tenants.find(tenant => tenant.tenantId === activeTenantId)
  const roleNames = activeTenant?.roleGroups?.flatMap(roleGroup =>
    (roleGroup.roles ?? []).map(role => role.name),
  )

  return roleNames?.includes(PermissionActions.AdminAccess) ?? false
}
